import React, { useEffect, createElement } from 'react';
import { BonusSection } from './components/BonusSection';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { Guarantee } from './components/Guarantee';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { PricingCard } from './components/PricingCard';
import { Testimonials } from './components/Testimonials';
import { TomiSection } from './components/TomiSection';
import { UrgencyBanner } from './components/UrgencyBanner';
type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: MetaPixel;
  loaded: boolean;
  version: string;
};
declare global {
  interface Window {
    fbq?: MetaPixel;
    _fbq?: MetaPixel;
  }
}
export function App() {
  useEffect(() => {
    try {
      if (window.fbq) return;
      const pixel = function (...args: unknown[]) {
        if (pixel.callMethod) {
          pixel.callMethod(...args);
        } else {
          pixel.queue.push(args);
        }
      } as MetaPixel;
      pixel.push = pixel;
      pixel.loaded = true;
      pixel.version = '2.0';
      pixel.queue = [];
      window.fbq = pixel;
      window._fbq = pixel;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      pixel('init', '1358713739554000');
      pixel('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel init skipped:', error);
    }
  }, []);
  return <>
      <noscript data-id="element-0">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1358713739554000&ev=PageView&noscript=1" alt="" data-id="element-1" />
      </noscript>
      <main className="flex min-h-screen w-full justify-center overflow-x-hidden bg-brand-beige" data-id="element-2">
        <div className="w-full max-w-3xl bg-brand-cream shadow-2xl" data-id="element-3">
          <UrgencyBanner data-id="element-4" />
          <Hero data-id="element-5" />
          <PainSection data-id="element-6" />
          <TomiSection data-id="element-7" />
          <BonusSection data-id="element-8" />
          <PricingCard data-id="element-9" />
          <Guarantee data-id="element-10" />
          <Testimonials data-id="element-11" />
          <FAQ data-id="element-12" />
          <FinalCTA data-id="element-13" />
          <Footer data-id="element-14" />
        </div>
      </main>
    </>;
}